// removed by extract-text-webpack-plugin
module.exports = {"container":"_1W0zOsK","image":"_36eVKGL","details":"_11v_yFR","term":"_1NGI_3f","price":"_3GC3ciN","item":"_2AqO0mn","product":"_1X9v1ZD","name":"_3GJua_o","meta":"_3FcFWyr","color":"_2iqu9DU","size":"_1DeddFy","quantity":"_11JyDT0","deleteItem":"_3T0222M"};


//////////////////
// WEBPACK FOOTER
// ./template/components/MiniBag/LineItem/index.css
// module id = ./template/components/MiniBag/LineItem/index.css
// module chunks = client.sitechrome